import { CollectionType } from './types'

import headerDisneyFan from './assets/header-image-disney-fan.png'
import thumbnailDisneyFan from './assets/thumbnail-disney-fan.png'
import headerTattyTeddy from './assets/header-image-tatty-teddy.png'
import thumbnailTattyTeddy from './assets/thumbnail-tatty-teddy.png'
import headerCathKidston from './assets/header-image-cath-kidston.png'
import thumbnailCathKidston from './assets/thumbnail-cath-kidston.png'
import headerChocolateLover from './assets/header-image-chocolate-lover.png'
import thumbnailChocolateLover from './assets/thumbnail-chocolate-lover.png'
import headerFootballFan from './assets/header-image-football-fan.png'
import thumbnailFootballFan from './assets/thumbnail-football-fan.png'
import headerProudGardener from './assets/header-image-proud-gardener.png'
import thumbnailProudGardener from './assets/thumbnail-proud-gardener.png'
import headerGamer from './assets/header-image-gamer.png'
import thumbnailGamer from './assets/thumbnail-gamer.png'
import headerPetParent from './assets/header-image-pet-parent.png'
import thumbnailPetParent from './assets/thumbnail-pet-parent.png'
import headerWellnessObsessed from './assets/header-image-wellness-obsessed.png'
import thumbnailWellnessObsessed from './assets/thumbnail-wellness-obsessed.png'

export const collectionAssets = {
  [CollectionType.DisneyFan]: {
    header: headerDisneyFan,
    thumbnail: thumbnailDisneyFan,
  },
  [CollectionType.TattyTeddyCollector]: {
    header: headerTattyTeddy,
    thumbnail: thumbnailTattyTeddy,
  },
  [CollectionType.CathKidstonFan]: {
    header: headerCathKidston,
    thumbnail: thumbnailCathKidston,
  },
  [CollectionType.ChocolateLover]: {
    header: headerChocolateLover,
    thumbnail: thumbnailChocolateLover,
  },
  [CollectionType.FootballFan]: {
    header: headerFootballFan,
    thumbnail: thumbnailFootballFan,
  },
  [CollectionType.ProudGardener]: {
    header: headerProudGardener,
    thumbnail: thumbnailProudGardener,
  },
  [CollectionType.Gamer]: {
    header: headerGamer,
    thumbnail: thumbnailGamer,
  },
  [CollectionType.PetParent]: {
    header: headerPetParent,
    thumbnail: thumbnailPetParent,
  },
  [CollectionType.WellnessObsessed]: {
    header: headerWellnessObsessed,
    thumbnail: thumbnailWellnessObsessed,
  },
} satisfies Record<CollectionType, { header: string; thumbnail: string }>
